import React from "react";

const Bar = ({ className = "" }) => (
  <div className={`animate-pulse rounded-md bg-black/[0.06] ${className}`} />
);

export const CardSkeleton = () => (
  <div className="rounded-3xl overflow-hidden border border-black/5 bg-white" data-testid="skeleton-card">
    <Bar className="aspect-[4/3] rounded-none" />
    <div className="p-5 space-y-3">
      <Bar className="h-4 w-3/4" />
      <Bar className="h-3 w-1/2" />
      <Bar className="h-4 w-1/3 mt-2" />
    </div>
  </div>
);

export const GridSkeleton = ({ count = 6 }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="skeleton-grid">
    {Array.from({ length: count }).map((_, i) => <CardSkeleton key={i} />)}
  </div>
);

export const DetailSkeleton = () => (
  <div className="space-y-6" data-testid="skeleton-detail">
    <Bar className="aspect-[16/9] md:aspect-[21/9] rounded-3xl" />
    <Bar className="h-8 w-1/2" />
    <Bar className="h-4 w-1/3" />
    <div className="space-y-2 pt-4">
      <Bar className="h-3 w-full" />
      <Bar className="h-3 w-11/12" />
      <Bar className="h-3 w-4/5" />
    </div>
  </div>
);

export default GridSkeleton;
